/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeSecretReference = {
  key: string;
  secretId: string;
};

/** @internal */
export const ComputeSecretReference$inboundSchema: z.ZodType<
  ComputeSecretReference,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  secret_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "secret_id": "secretId",
  });
});
/** @internal */
export type ComputeSecretReference$Outbound = {
  key: string;
  secret_id: string;
};

/** @internal */
export const ComputeSecretReference$outboundSchema: z.ZodType<
  ComputeSecretReference$Outbound,
  z.ZodTypeDef,
  ComputeSecretReference
> = z.object({
  key: z.string(),
  secretId: z.string(),
}).transform((v) => {
  return remap$(v, {
    secretId: "secret_id",
  });
});

export function computeSecretReferenceToJSON(
  computeSecretReference: ComputeSecretReference,
): string {
  return JSON.stringify(
    ComputeSecretReference$outboundSchema.parse(computeSecretReference),
  );
}
export function computeSecretReferenceFromJSON(
  jsonString: string,
): SafeParseResult<ComputeSecretReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeSecretReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeSecretReference' from JSON`,
  );
}
